const groupTitles = {
    data: {
        en: "DATA",
        tr: "VERİ"
    },
    dataImport: {
        en: "DATA IMPORT",
        tr: "VERİ İŞLEMLERİ"
    },
    operation: {
        en: "OPERATION",
        tr: "OPERASYON"
    },
    reports: {
        en: "REPORTS",
        tr: "RAPORLAR"
    },
    settings: {
        en: "SETTINGS",
        tr: "AYARLAR"
    },
    help: {
        en: "HELP",
        tr: "YARDIM"
    }
}

export default groupTitles